import { render } from "./AddUser.vue?vue&type=template&id=39e788c8"
import script from "./AddUser.vue?vue&type=script&lang=js"
export * from "./AddUser.vue?vue&type=script&lang=js"
script.render = render

export default script